import { render } from "./VaccineSalesNew.vue?vue&type=template&id=26e96bc8"
import script from "./VaccineSalesNew.vue?vue&type=script&lang=js"
export * from "./VaccineSalesNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/clinic/VaccineSalesNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26e96bc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26e96bc8', __exports__)) {
    api.reload('26e96bc8', __exports__)
  }
  
  module.hot.accept("./VaccineSalesNew.vue?vue&type=template&id=26e96bc8", () => {
    api.rerender('26e96bc8', render)
  })

}


export default __exports__